import { LayaGL } from "../../layagl/LayaGL";
import { Color } from "../../maths/Color";
import { Matrix } from "../../maths/Matrix";
import { Vector2 } from "../../maths/Vector2";
import { Vector4 } from "../../maths/Vector4";
import { RenderTargetFormat } from "../../RenderEngine/RenderEnum/RenderTargetFormat";
import { Material } from "../../resource/Material";
import { RenderTexture2D } from "../../resource/RenderTexture2D";
import { ClassUtils } from "../../utils/ClassUtils";
import { ColorUtils } from "../../utils/ColorUtils";
import { PostProcess2DEffect } from "../PostProcess2DEffect";
import { Blit2DCMD } from "../Scene2DSpecial/RenderCMD2D/Blit2DCMD";
export class GlowEffect2D extends PostProcess2DEffect {
    get sv_blurInfo1() {
        return this._sv_blurInfo1;
    }
    set sv_blurInfo1(value) {
        if (value !== this._sv_blurInfo1) {
            value.cloneTo(this._sv_blurInfo1);
        }
        this._glowMat && (this._glowMat.setVector4("u_blurInfo1", this._sv_blurInfo1));
        this._owner && this._owner._onChangeRender();
    }
    get sv_blurInfo2() {
        return this._sv_blurInfo2;
    }
    set sv_blurInfo2(value) {
        if (value !== this._sv_blurInfo2) {
            value.cloneTo(this._sv_blurInfo2);
        }
        this._glowMat && (this._glowMat.setVector4("u_blurInfo2", this._sv_blurInfo2));
        this._owner && this._owner._onChangeRender();
    }
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this._colorVec.fromArray(ColorUtils.create(value).arrColor);
        this._glowMat && (this._glowMat.setVector4("u_color", this._colorVec));
        this._owner && this._owner._onChangeRender();
    }
    get blur() {
        return this._sv_blurInfo1.y;
    }
    set blur(value) {
        this._sv_blurInfo1.x = this._sv_blurInfo1.y = value;
        this.sv_blurInfo1 = this._sv_blurInfo1;
    }
    get offsetY() {
        return this._sv_blurInfo1.w;
    }
    set offsetY(value) {
        if (value !== this._sv_blurInfo1.w) {
            this._sv_blurInfo1.w = value;
            this.sv_blurInfo1 = this._sv_blurInfo1;
        }
    }
    get offsetX() {
        return this._sv_blurInfo1.z;
    }
    set offsetX(value) {
        if (value !== this._sv_blurInfo1.z) {
            this._sv_blurInfo1.z = value;
            this.sv_blurInfo1 = this._sv_blurInfo1;
        }
    }
    constructor(color, blur, offX, offY) {
        super();
        this._blitcenterScale = new Vector2();
        this._sv_blurInfo1 = new Vector4();
        this._sv_blurInfo2 = new Vector4(0, 0, 1, 0);
        this._colorVec = new Vector4();
        this.color = color || "#000";
        this.blur = blur !== null && blur !== void 0 ? blur : 4;
        this.offsetX = offX !== null && offX !== void 0 ? offX : 6;
        this.offsetY = offY !== null && offY !== void 0 ? offY : 6;
    }
    effectInit(postprocess) {
        this._owner = postprocess;
        (!this._blitmat) && (this._blitmat = new Material());
        this._blitmat.setShaderName("ColorEffect2D");
        if (!this._blitElement) {
            this._blitElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
            this._blitElement.geometry = Blit2DCMD.InvertQuadGeometry;
            this._blitElement.nodeCommonMap = null;
            this._blitElement.renderStateIsBySprite = false;
            this._blitElement.materialShaderData = this._blitmat.shaderData;
            this._blitElement.subShader = this._blitmat.shader.getSubShaderAt(0);
        }
        (!this._glowMat) && (this._glowMat = new Material());
        this._glowMat.setShaderName("glow2D");
        this._glowMat.setVector4("u_color", this._colorVec);
        this._glowMat.setVector4("u_blurInfo1", this.sv_blurInfo1);
        this._glowMat.lock = true;
        if (!this._glowElement) {
            this._glowElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
            this._glowElement.geometry = Blit2DCMD.InvertQuadGeometry;
            this._glowElement.nodeCommonMap = null;
            this._glowElement.renderStateIsBySprite = false;
            this._glowElement.materialShaderData = this._glowMat.shaderData;
            this._glowElement.subShader = this._glowMat.shader.getSubShaderAt(0);
        }
        (!this._compositeMat) && (this._compositeMat = new Material());
        this._compositeMat.setShaderName("ColorEffect2D");
        if (!this._compositeElement) {
            this._compositeElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
            this._compositeElement.geometry = Blit2DCMD.InvertQuadGeometry;
            this._compositeElement.nodeCommonMap = null;
            this._compositeElement.renderStateIsBySprite = false;
            this._compositeElement.materialShaderData = this._compositeMat.shaderData;
            this._compositeElement.subShader = this._compositeMat.shader.getSubShaderAt(0);
        }
    }
    render(context) {
        let marginLeft = 50;
        let marginTop = 50;
        let width = context.indirectTarget.width;
        let height = context.indirectTarget.height;
        let texwidth = width + 2 * marginLeft;
        let texheight = height + 2 * marginTop;
        this._checkRenderTarget(texwidth, texheight, context);
        this._blitmat.setTexture("u_MainTex", context.indirectTarget);
        this._blitcenterScale.setValue(width / texwidth, height / texheight);
        this._blitmat.setVector2("u_centerScale", this._blitcenterScale);
        context.command.setRenderTarget(this._blitExtendRT, true, Color.CLEAR);
        context.command.drawRenderElement(this._blitElement, Matrix.EMPTY);
        this._glowMat.setVector2("u_centerScale", Vector2.ONE);
        this._glowMat.setTexture("u_MainTex", this._blitExtendRT);
        this._sv_blurInfo2.x = width;
        this._sv_blurInfo2.y = height;
        this._glowMat.setVector4("u_blurInfo2", this._sv_blurInfo2);
        context.command.setRenderTarget(this._destRT, true, Color.CLEAR);
        context.command.drawRenderElement(this._glowElement, Matrix.EMPTY);
        this._compositeMat.setTexture("u_MainTex", this._blitExtendRT);
        this._compositeMat.setVector2("u_centerScale", Vector2.ONE);
        context.command.drawRenderElement(this._compositeElement, Matrix.EMPTY);
        context.destination = this._destRT;
    }
    _checkRenderTarget(width, height, context) {
        if (this._destRT && (this._destRT._inPool || this._destRT.destroyed || this._destRT.width !== width || this._destRT.height !== height)) {
            RenderTexture2D.recoverToPool(this._destRT);
            this._destRT = null;
        }
        if (this._blitExtendRT && (this._blitExtendRT._inPool || this._blitExtendRT.destroyed || this._blitExtendRT.width !== width || this._blitExtendRT.height !== height)) {
            RenderTexture2D.recoverToPool(this._blitExtendRT);
            this._blitExtendRT = null;
        }
        if (!this._destRT) {
            this._destRT = context.getRenderTexture(width, height, RenderTargetFormat.R8G8B8A8, RenderTargetFormat.None);
        }
        if (!this._blitExtendRT) {
            this._blitExtendRT = context.getRenderTexture(width, height, RenderTargetFormat.R8G8B8A8, RenderTargetFormat.None);
        }
    }
    clearRT(context) {
        if (this._blitExtendRT && this._blitExtendRT !== context.destination) {
            RenderTexture2D.recoverToPool(this._blitExtendRT);
            this._blitExtendRT = null;
        }
        if (this._destRT && this._destRT !== context.destination) {
            RenderTexture2D.recoverToPool(this._destRT);
            this._destRT = null;
        }
    }
    destroy() {
        super.destroy();
        if (this._destRT) {
            RenderTexture2D.recoverToPool(this._destRT);
        }
        this._destRT = null;
        if (this._blitExtendRT) {
            RenderTexture2D.recoverToPool(this._blitExtendRT);
        }
        this._blitExtendRT = null;
        this._blitmat && (this._blitmat.destroy());
        this._blitmat = null;
        this._blitElement && (this._blitElement.destroy());
        this._blitElement = null;
        this._glowMat && (this._glowMat.destroy());
        this._glowMat = null;
        this._glowElement && (this._glowElement.destroy());
        this._glowElement = null;
        this._compositeMat && (this._compositeMat.destroy());
        this._compositeMat = null;
        this._compositeElement && (this._compositeElement.destroy());
        this._compositeElement = null;
    }
}
ClassUtils.regClass("GlowEffect2D", GlowEffect2D);
